<template>
    <div class="d-flex justify-content-between mt-1">
        <button v-if="showEditBtn" class="btn tertiary flex-all fs-smaller" @click="openEditEvent">
          Edit
        </button>

        <button v-if="showReservationsBtn" class="btn tertiary flex-all mx-1 fs-smaller" @click="routeTo('reservationsEvent')">
          Reservations
        </button>

        <button class="btn bg-color-6 lightest tertiary flex-all fs-smaller" @click="showCanceledPopup" v-if="showCanceledBtn">
            Canceled
        </button>

        <button v-if="showBookingBtn" class="btn flex-all fs-smaller" v-tooltip="bookButtonLook.reasons" :class="bookButtonLook.classes" @click="bookButtonPress">
          {{bookButtonLook.label}}
        </button>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { eventMixin } from '@/mixins/event'

    export default {
        props: {
            event: Object
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getUserDetails',
                'getUserAccessType'
            ]),
            showEditBtn() {
                return this.accessPermissionFilter(['admin', 'supervisor']);
            },
            showReservationsBtn() {
                // Hide to viewer
                return !this.accessPermissionFilter(['viewer']);
            },
            showCanceledBtn() {
                // Admin never sees the canceled btn
                if (this.accessPermissionFilter(['admin', 'mainSupervisor', 'viewer'])) {
                    return false;
                }

                return this.event.status == -1;
            },
            showBookingBtn() {
                const { status, shareType } = this.event;

                const isBasicOrRestrictedAndCanceled = status === -1 && this.accessPermissionFilter(['basic', 'restricted', 'agentSupervisor', 'marketingSupervisor', 'myTeamSupervisor']);
                const isViewer = this.accessPermissionFilter(['viewer']);
                const isVirtualRoosterAndClosed = shareType === 2 && status === -2;
                const isAdminOrSupervisor = this.accessPermissionFilter(['admin', 'mainSupervisor']);


                if (isViewer || isVirtualRoosterAndClosed || isBasicOrRestrictedAndCanceled) {
                    return false;
                }

                if (isAdminOrSupervisor || !isBasicOrRestrictedAndCanceled) {
                    return true;
                }

                return this.canISellThisEvent(this.event).allowed;
            },
            bookButtonLook() {
                let btnOpacity = (this.event.quantityAvailable < 1 && this.event.availabilityType != 1)? 'opacity-50' : '';

                if (this.canISellThisEvent(this.event).allowed ){
                    return {
                        label: 'BOOK',
                        classes: btnOpacity + ' '
                    }
                } else {
                    return {
                        label: 'CLOSED',
                        classes: btnOpacity + ' bg-dark',
                        reasons: this.canISellThisEvent(this.event).reasons.join(", ")+"."
                    }
                }
            }
        },
        mixins: [
            eventMixin
        ],
        methods: {
            ...mapActions([
                'resetClonedReservation',
                'updateClonedReservation',
                'openModal',
                'setReservationSelectedEvent',
                'setReservationSelectedProduct',
                'setAsNotCreatingSingleEvent',
                'setSelectedEventListReservations',
                'setBasePricesInEvent',
                'setSellPricesInEvent',
            ]),
            routeTo(route) {
                this.setSelectedEventListReservations(this.event);
                this.$router.push({ name: route });
            },
            bookButtonPress() {
                // If current user cannot sell this event this will not pass, except if it is an admin or mainSupervisor
                if (this.canISellThisEvent(this.event).allowed == false && !this.accessPermissionFilter(['admin', 'mainSupervisor'])) {
                    return false;
                }
                // If admin and event is canceled (admin can see the book button even if the event is canceled)
                if (this.event.status == -1) {
                    this.$dialog.alert('Be aware, this event "'+this.event.product.name+'" has been canceled. You can only see the "Book" button because your are an ' + this.getUserAccessType.label + '.<br>' + (this.event.statusMessage ? 'Cancel message: ' + this.event.statusMessage : ''), {okText: 'OK'})
                    .then(() => {
                        this.addReservation();
                    })
                    .catch(() => {
                        this.addReservation();
                    });
                } else {
                    this.addReservation();
                }
            },
            addReservation() {
                if (this.event.quantityAvailable > 0 || this.event.availabilityType == 1) {
                    this.setSellPricesInEvent();
                    this.setReservationSelectedEvent(this.event);
                    this.setReservationSelectedProduct(this.event.product);
                    this.$router.push('/reservation/resume');
                } else {
                    this.$toasted.info('Event fully booked');
                }
            },
            openEditEvent() {
                this.setAsNotCreatingSingleEvent();
                this.setBasePricesInEvent();
                this.openModal('EventEdit');
            },
            showCanceledPopup() {
                this.$dialog.alert('The event "'+this.event.product.name+'" has been canceled.<br>' + (this.event.statusMessage? 'Cancel message: '+this.event.statusMessage : ''), {okText: 'OK'})
                .then(function () {})
                .catch(function () {});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Links.vue?cc5036a4